<template>
  <div v-if="visible" class="unlock_dialog">
    <div class="unlock_dialog_content">
      <img
        class="unlock_dialog_content_header"
        src="~@/assets/images/common/head.png"
        alt=""
      />
      <img
        src="~@/assets/images/common/close.png"
        alt=""
        class="unlock_dialog_content_close"
        @click="cancel"
      />
      <div class="unlock_dialog_content_body">
        <h3>温馨提示</h3>
        <p>{{ tips }}</p>
        <div class="check-mod">
          <div
            class="check-mod-item"
            :class="{ checked: current === 1 }"
            @click="current = 1"
          >
            <h5 class="check-mod-title">解锁方式1</h5>
            <p class="check-mod-content" v-html="leftContent"></p>
            <p v-if="leftPrice" class="check-mod-price">
              <span>￥</span>{{ leftPrice }}
            </p>
          </div>
          <div
            class="check-mod-item"
            :class="{ checked: current === 2 }"
            @click="current = 2"
          >
            <h5 class="check-mod-title">解锁方式2</h5>
            <p class="check-mod-content" v-html="rightContent"></p>
            <p v-if="rightPrice" class="check-mod-price">
              <span>￥</span>{{ rightPrice }}
            </p>
          </div>
        </div>
      </div>
      <div class="unlock_dialog_content_footer">
        <a href="javascript:void(0);" @click="confirm">立即购买</a>
      </div>
    </div>
    <div class="unlock_dialog_mask"></div>
  </div>
</template>

<script>
export default {
  name: 'UnlockDialog',
  props: {
    tips: {
      type: String,
      default: '请选择解锁方式'
    },
    leftContent: {
      type: String,
      default: '升级题库会员<br />额外尊享<br />20+权益'
    },
    leftPrice: {
      type: Number,
      default: 0
    },
    rightContent: {
      type: String,
      default: '购买课程<br />可无限次<br />做题'
    },
    rightPrice: {
      type: Number,
      default: 0
    },
    checked: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      visible: false,
      current: 1
    }
  },
  wathc: {
    checked(val) {
      this.current = val
    }
  },
  methods: {
    confirm() {
      this.$emit('done', this.current)
    },
    cancel() {
      this.$emit('cancel', this.current)
    }
  }
}
</script>

<style lang="scss" scoped>
.unlock_dialog {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  &_content {
    padding-bottom: 14px;
    width: 300px;
    min-height: 200px;
    background: #fff;
    border-radius: 24px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;

    &_header {
      width: 300px;
      height: 149px;
      position: absolute;
      top: -39px;
      z-index: -1;
    }

    &_close {
      width: 16px;
      height: 16px;
      cursor: pointer;
      position: absolute;
      right: 17px;
      top: 12px;
    }

    &_body {
      padding-top: 72px;
      width: 100%;
      height: 100%;

      h3 {
        font-weight: bold;
        font-size: 18px;
        color: #222;
        text-align: center;
      }

      p {
        padding: 5px 10px;
        text-align: center;
        color: #666;
        line-height: 19px;
        font-size: 14px;
      }

      .check-mod {
        margin: 7px 8px;
        display: flex;

        &-item {
          margin-left: 12px;
          width: 124px;
          height: 150px;
          background: linear-gradient(
              128deg,
              #f8dabf 0%,
              #fffaf1 40%,
              #ffe7b5 100%
            ),
            #fff0e0;
          border-radius: 18px;
          cursor: pointer;

          .check-mod-title {
            margin-top: 14px;
            font-weight: bold;
            font-size: 14px;
            color: #593e27;
            line-height: 19px;
            text-align: center;

            &::after {
              display: block;
              content: '';
              width: 12px;
              height: 3px;
              background: #9b6f4c;
              border-radius: 2px;
              position: absolute;
              left: 50%;
              bottom: -6px;
              transform: translateX(-50%);
            }
          }

          .check-mod-content {
            margin-top: 6px;
            font-size: 14px;
            color: #9b6f4c;
            line-height: 19px;
            text-align: center;
          }

          .check-mod-price {
            margin-top: 11px;
            font-weight: bold;
            font-size: 16px;
            color: #fa4125;
            line-height: 21px;
            text-align: center;
          }

          &.checked {
            background: url(~@/assets/images/common/vip_checked_bg.png);
            background-size: 100% 100%;
            border: 2px solid #fa4125;
            position: relative;

            &::after {
              display: block;
              content: '';
              width: 26px;
              height: 26px;
              background: url(~@/assets/images/common/vip_checked_icon.png)
                no-repeat center;
              background-size: 26px 26px;
              position: absolute;
              right: 0;
              bottom: 0;
            }

            .check-mod-title {
              color: #fff;

              &::after {
                background: #fff;
              }
            }

            .check-mod-content {
              color: #fff;
            }

            .check-mod-price {
              color: #ffdd9e;
            }
          }
        }
      }
    }

    &_footer {
      margin-top: 12px;
      text-align: center;

      a {
        display: inline-block;
        width: 183px;
        height: 44px;
        background: linear-gradient(90deg, #ff7a00, #ff3a00);
        border-radius: 22px;
        color: #fff;
        line-height: 44px;
        text-align: center;
        cursor: pointer;
      }
    }
  }

  &_mask {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1;
  }
}
</style>
